import React from 'react';

import cn from 'classnames';

import cls from './PushNotification.module.css';

interface IPushNotificationProps {
    textContent: string;
    isOpen: boolean;
    containerStyles?: string;
    inlineStyles?: React.CSSProperties;
    pushStyles?: string;
}

export const PushNotification = ({
    textContent,
    isOpen,
    containerStyles,
    inlineStyles,
    pushStyles,
}: IPushNotificationProps) => (
    <div
        className={cn(cls.PushNotificationContainer, containerStyles, isOpen && cls.isOpen)}
        style={inlineStyles}
    >
        <div className={cn(cls.PushNotification, pushStyles)}>
            <span className={cls.text}>{textContent}</span>
        </div>
    </div>

    // <span
    //     className={classNames(cls.PushNotification, [classes], isOpen && cls.isOpen)}
    //     style={inlineStyles ?? {}}
    // >
    //     {textContent}
    // </span>
);
